<span #trigger *ngIf="info.tooltips?.length">
   <button mat-icon-button *ngIf="breakpoints.large" (mouseenter)="toggle( trigger )" (mouseleave)="tooltipRef.detach()">
      <mat-icon class="material-icons-outlined">info</mat-icon>
   </button>

   <button mat-icon-button *ngIf="!breakpoints.large" (click)="toggle( trigger )">
      <mat-icon class="material-icons-outlined">info</mat-icon>
   </button>
</span>
